/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qc_Run_Review_PromptInputs */



/**
* | output |
* | --- |
* | "Press Start to review this event group." |
*
* @param {Qc_Run_Review_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const qc_run_review_prompt = /** @type {((inputs?: Qc_Run_Review_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qc_Run_Review_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Appuyez sur Démarrer pour réviser ce groupe d'événements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Drücken Sie Start, um diese Event-Gruppe zu prüfen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Premi Avvia per revisionare questo gruppo di eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Нажмите «Старт», чтобы проверить эту группу событий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pulse Iniciar para revisar este grupo de eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("按“开始”以审阅此事件组。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始を押してこのイベントグループをレビューしてください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इस इवेंट समूह की समीक्षा के लिए स्टार्ट दबाएँ।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prima Iniciar para rever este grupo de eventos.")
	return /** @type {LocalizedString} */ ("Press Start to review this event group.")
});